module.exports = __webpack_public_path__ + "static/media/GT-Eesti-Text-Book.dae89b62.woff";


//////////////////
// WEBPACK FOOTER
// ./src/GT-Eesti-Text-Book.woff
// module id = 73
// module chunks = 0